import { DataField } from "@iventis/domain-model/model/dataField";
import { SystemDataFieldName } from "@iventis/domain-model/model/systemDataFieldName";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { Units } from "@iventis/domain-model/model/units";
import { MeasurementKind } from "@iventis/utilities";

/*
 * Units for area and length formula operands. Area and length are stored in metres and are converted with
 * convertFromMeters in @iventis/utilities, which must match FormulaUnitConversion.cs on the backend.
 */

/** Units the user can pick for an area or length formula operand, in display order. */
export const FORMULA_UNIT_OPTIONS: Units[] = [Units.Meters, Units.Kilometers, Units.Feet, Units.Miles];

/**
 * Returns whether a data field's value can be converted to another unit in a formula.
 * To support units on another system data field, add it to the matching case.
 * @param dataField - The referenced data field
 * @returns Area or Length for system data fields stored in metres, otherwise null
 */
export const getFormulaUnitKind = (dataField: DataField | null | undefined): MeasurementKind | null => {
    switch (dataField?.systemDataFieldName) {
        case SystemDataFieldName.MapObjectArea:
            return MeasurementKind.Area;
        case SystemDataFieldName.MapObjectLength:
        case SystemDataFieldName.ModelAltitude:
            return MeasurementKind.Length;
        default:
            return null;
    }
};

/**
 * Returns the unit an area or length formula chip starts with when it is added
 * @param unitOfMeasurement - The user's metric or imperial preference
 */
export const getDefaultFormulaUnit = (unitOfMeasurement: UnitOfMeasurement | null | undefined): Units =>
    unitOfMeasurement === UnitOfMeasurement.Imperial ? Units.Feet : Units.Meters;
